import { ReactElement } from "react";

import { PhoneNumberMessageClass } from "~frontend/__generated__/graphql";
import { MessageClassDisplayName } from "~frontend/components/MessageClassDisplayName";
import { TableControls } from "~frontend/components/Table";
import { useCurrentUserIsStaff } from "~frontend/providers/LoggedInUserProvider";
import {
  PHONE_NUMBER_SORTS,
  PROVIDER_LABELS,
} from "~frontend/routes/subaccounts/phoneNumberList/constants";

export default function PhoneNumberListControls({
  onClickImportNumber,
  providerFilter,
  setProviderFilter,
  messageClassFilter,
  setMessageClassFilter,
  sort,
  setSort,
}: {
  onClickImportNumber: () => Promise<void>;
  providerFilter: string[];
  setProviderFilter: (newProviderFilter: string[]) => void;
  messageClassFilter: string[];
  setMessageClassFilter: (newProviderFilter: string[]) => void;
  sort: string;
  setSort: (newSort: string) => void;
}): ReactElement {
  const isStaff = useCurrentUserIsStaff();

  const addButtons = [];
  if (isStaff) {
    addButtons.push({
      label: "Import",
      onClick: onClickImportNumber,
      sx: { fontSize: 12 },
      id: "import-phone-number",
    });
  }

  const messageClassOptions = Object.values(PhoneNumberMessageClass)
    .filter(m => m !== PhoneNumberMessageClass.Unregistered)
    .map(messageClass => ({
      value: messageClass,
      label: <MessageClassDisplayName messageClass={messageClass} />,
    }));

  return (
    <TableControls
      addButtons={addButtons}
      filters={[
        {
          id: "provider",
          label: "Provider",
          value: providerFilter,
          onChange: setProviderFilter,
          options: PROVIDER_LABELS,
          multi: true,
        },
        {
          id: "messageClass",
          label: "Message Class",
          value: messageClassFilter,
          onChange: setMessageClassFilter,
          options: messageClassOptions,
          multi: true,
        },
      ]}
      sort={{
        value: sort,
        onChange: setSort,
        options: PHONE_NUMBER_SORTS,
      }}
      paperStyles={{
        paddingTop: 3,
        paddingBottom: 3,
      }}
    />
  );
}
